import { client, clientApisV2 } from '@/modules/HttpClient';
import type * as I from '@/interface';
import { getRecommendationsByKey } from '../recommend';

/**
 * 获取顶部产品列表
 * @param args
 * @returns
 */
export const getNavProductList = async (args: I.IGetNavProductListArgs): Promise<I.IGetNavProductListResponse> => {
    const res = await client.get<I.IGetNavProductListResponse>(
        '/nav/products/?no-mobile-redirection=1&viaReoAPI=true',
        args as unknown as Record<string, string>,
    );
    return res;
};

/**
 * 搜索导航栏产品
 * @param args
 * @returns
 */
export const searchNavProductList = async (args: I.ISearchNavProductListArgs): Promise<I.ISearchNavProductListRes> => {
    const res = await clientApisV2.get<I.ISearchNavProductListRes>(
        '/official-site-data-cache/common/navigate/search-bar/product/list',
        args as unknown as Record<string, string>,
    );
    return res;
};

/**
 * 获取header搜索推荐位
 * @param keys
 * @returns
 */
export async function getNavProductSearchRecommend(lang: string): Promise<I.IProductRecommendData> {
    const result = await getRecommendationsByKey({
        keys: ['topSearchRecommend'],
        lang,
    });
    return (result['topSearchRecommend'] ?? { type: 'product', data: [] }) as I.IProductRecommendData;
}

/**
 * 获取底部推荐产品列表
 * @param lang
 * @returns
 */
export async function getFooterRecommendProducts(lang: string): Promise<I.IProductRecommendData> {
    const result = await getRecommendationsByKey({
        keys: ['footerBottomRecommend'],
        lang,
    });
    return (result['footerBottomRecommend'] ?? { type: 'product', data: [] }) as I.IProductRecommendData;
}
